import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/pages/genaral.css';
import Routess from './pathes';
import { MusicProvider } from './components/layout/MusicContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MusicProvider>
      <Routess />
    </MusicProvider>
  </React.StrictMode>
);